import React, { useEffect } from "react";
import { setRoutePermissionData, updateRouteItem } from "../../../features/addLoad/addLoadSlice";
import { useDispatch } from "react-redux";
import {  showNestedModal } from "../../../features/modal/modalSlice";
import { useSelector } from "react-redux";
import * as IoIcons from "react-icons/io5"
import { useState } from "react";
import axios from "axios";

const LoadMapInputs = ({ onClick, selectedItem, item, index, locationData, handleClick}) => {

  const dispatch = useDispatch();
  const { route } = useSelector((state) => state.addLoad);

  const handleOptionClick = (item) => {

    const found = findLocationFromAddress(locationData, item?.description)

    const updatedItem = {
      id: selectedItem?.id,
      adres:item?.description,
      locationData: {
        il: found?.city,
        ilce: found?.town,
        location: found?.location,
        bolge: found?.region,
        lat: found?.lat,
        lng: found?.lng,
        ilceId: found?.townId,
        ilId: found?.cityId,
      },
    };

    dispatch(updateRouteItem(updatedItem));
  };

  const findLocationFromAddress = (data, address) => {
    return data?.find((item) => {
      return address?.includes(item?.city) && address?.includes(item?.town);
    });
  };
 
  const handleDeleteRoute = (item) => {
    dispatch(showNestedModal("MapDeleteRoute"));
    dispatch(setRoutePermissionData(item));
  }

  return (
    <>
      <div onClick={onClick} className={`${selectedItem?.id === item?.id && "selected"} locations`} >
        {route.length > 2 && (
          <button className="delete-btn" onClick={() => handleDeleteRoute(item) }>
          <IoIcons.IoClose/>
          </button>
        )}

        {/* <input value={value} onChange={handleSearch} type="text" placeholder="Ara" /> */}
  
        <p>
          {item?.locationType === "yukleme"
            ? `${index + 1}. Yükleme `
            : "Boşaltma "}
          Adresi: <span>{item?.adres}</span> 
        </p>

      </div>
    </>
  );
};

export default LoadMapInputs;

//! options?.length > 1 && show && 

//! deneme
